
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1639_12416)"}},[_c('path',{attrs:{"d":"M9.501 0c1.263 0 2.403.447 3.231 1.17.828.722 1.34 1.72 1.34 2.82 0 1.102-.512 2.098-1.34 2.82-.828.723-1.97 1.17-3.23 1.17-1.263 0-2.403-.447-3.231-1.17-.827-.722-1.34-1.718-1.34-2.82 0-1.103.513-2.098 1.34-2.82C7.099.446 8.241 0 9.501 0z","fill":"#0E6199"}}),_c('path',{attrs:{"d":"M9.501 0c.26 0 .512.02.76.055.094.357.145.727.145 1.11 0 2.43-2.036 4.46-4.76 4.967a3.61 3.61 0 01-.714-2.142c0-1.103.512-2.098 1.339-2.82C7.099.446 8.241 0 9.501 0z","fill":"#1269A3"}}),_c('path',{attrs:{"d":"M.004 14.072c-.014-.685.045-2.003 1.34-3.153 1.242-1.102 3.62-2.023 8.172-1.969 4.541.055 6.916.944 8.153 2.011 1.294 1.118 1.356 2.389 1.325 3.18v.003c0 1.87-2.386 3.047-5.494 3.556-1.194.196-2.5.295-3.813.297a25.244 25.244 0 01-3.837-.275c-3.256-.504-5.818-1.716-5.852-3.65h.006z","fill":"#0E6199"}}),_c('path',{attrs:{"d":"M0 13.95c-.002-.712.12-1.943 1.343-3.028C2.58 9.824 4.94 8.906 9.451 8.952c.494.535.776 1.143.776 1.79 0 2.104-2.975 3.81-6.646 3.81-1.32 0-2.548-.222-3.583-.601h.003z","fill":"#1269A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.786 10.842c.114.484.941 3.615.941 4.258 0 .64-2.488.514-2.59.025-.1-.49.58-3.036 1.004-4.303.293-.866.526-.464.642.02h.003z","fill":"#FCD112"}}),_c('path',{attrs:{"d":"M8.887 8.95a26.302 26.302 0 011.126.01 27.64 27.64 0 00-.19.981c-.023.161-.618.23-.689.01-.065-.333-.188-.673-.247-1.003v.002z","fill":"#FCD112"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1639_12416"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h19v18H0z"}})])])])
          )
        }
      }
    